export default __webpack_public_path__ + "static/media/icon-matri.1e4be5f9.svg";